import { Bar } from 'react-chartjs-2';
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  type ChartOptions,
  LinearScale,
  Tooltip,
  type ChartData
} from 'chart.js';
import { useChart } from '../shared/hooks';
import { CHART_TYPE } from '../shared/types';
import { type ChartValuesAmount } from 'src/shared/types/chartsData';

Chart.register(CategoryScale, LinearScale, BarController, BarElement, Tooltip);

type BarChartProps = {
  data: ChartValuesAmount;
  labels: string[];
  stacked: boolean;
};
const BarChart = ({ data, labels, stacked = false }: BarChartProps) => {
  const { chartData, options } = useChart(CHART_TYPE.BAR, data, labels, stacked);
  if (!chartData) {
    return <></>;
  }

  return <Bar data={chartData as ChartData<'bar'>} options={options as ChartOptions<'bar'>} />;
};

export default BarChart;
